module.exports = __webpack_public_path__ + "static/media/nissan_boy_thankyou.cffd6856.png";